import SEO from '../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import BasicSpecs from './components/BasicSpecs';
import Merits from './components/Merits';
import AnnualFeeGuide from './components/AnnualFeeGuide';
import PointGuide from './components/PointGuide';
import Demerits from './components/Demerits';
import Reviews from './components/Reviews';
import SuitableFor from './components/SuitableFor';
import HowToApply from './components/HowToApply';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function DCardPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    "name": "dカード GOLD U",
    "description": "ドコモユーザーにおすすめのゴールドクレジットカード。携帯料金の高還元ポイント、充実した付帯保険、dポイントの効率的な貯め方が特徴。",
    "brand": {
      "@type": "Brand",
      "name": "NTTドコモ"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "JPY",
      "availability": "https://schema.org/InStock"
    },
    "url": `${siteUrl}/dcard`
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="dカード GOLD U詳細｜ドコモユーザー向けゴールドカード徹底解説｜クレカ比較ナビ"
        description="dカード GOLD Uの詳細情報。ドコモ携帯料金の高還元、dポイントの貯め方、付帯保険、特典を徹底解説。メリット・デメリット・口コミ・申込方法も詳しく紹介します。"
        keywords="dカード,GOLD U,ドコモ,ゴールドカード,dポイント,クレジットカード,携帯料金還元"
        canonical="/dcard"
        structuredData={structuredData}
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: 'カード詳細', path: '/ranking' },
        { label: 'dカード GOLD U' }
      ]} />
      <Hero />
      <CTASection />
      <BasicSpecs />
      <Merits />
      <AnnualFeeGuide />
      <PointGuide />
      <Demerits />
      <CTASection />
      <Reviews />
      <SuitableFor />
      <HowToApply />
      <CTASection />
      <Footer />
    </div>
  );
}
